import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

type Params = {
	id: string;
	response: boolean;
	message?: string;
};

export const respondToMeetingRescheduleRequest = makeSubmitData<Params>(
	"meetingRescheduleRequestResponse"
);
